{
  "app_type": "front",
  "project_name": "atmo-front",
  "dependencies": [
    "atmo-back",
    "contributors",
    "report-generator",
    "atlas-as-a-service",
    "production-unit-lister",
    "user-management",
    "referencial",
    "file-transfer-management",
    "document"
  ],
  "fixtures": [],
  "extra_steps": [],
  "groups": [
    "/BaseUser",
    "/BaseUser/SocotecUser",
    "/BaseUser/ExternalUser",
    "/Developer",
    "/Developer/SocioDev"
  ]
}
